import React, { memo, useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Logo from "../images/logo.svg";
import personIcon from "../images/person.svg";
import EmailSuccessImg from "../images/Email-success-img.svg";
import EmailVerificationAlreadyDone from "../images/Email-verification-already-done.png";
import CustomPageLoading from "./comman/CustomPageLoading";
import { useToast } from "./comman/CustomMessages";

import {
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircleImg from "../images/circle-pattern-1.png";
import ArrowDown from "../images/arrow-down.svg";
import VisibilityOff from "../images/eye-close.svg";
import Visibility from "../images/eye-icon.svg";
import LockIcon from "../images/lock_icon.svg";
import refrechIcon from "../images/refresh-icon.svg";
import captchaIcon from "../images/re-load.svg";
import emailIcon from "../images/email-icon.svg";
import phoneIcon from "../images/phone-icon.svg";
import backIcon from "../images/back-arrow-left.svg";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD,
  SIGNIN_ROUTE,
} from "../constants/RoutePath";
import { useFormik } from "formik";
import * as Yup from "yup";

import { USER_VERIFY_EMAIL_URL} from "../constants/ApiRoute";
import { CustomMessage, deCryptFun, enCryptFun } from "./comman/CustomFunction";
import API from "./comman/API";
import CustomLoader from "./comman/CustomLoader";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const initialValues = {
  password: "",
  confirmPassword: "",
};
const EmailConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useToast();

  //  const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const value = queryParams.get("value");
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const id = parts[parts.length - 1];
  const cleanId = id.split("%")[0];
  const [loading, setLoading] = useState(false);
  const [isAlreadyVerify, setIsAlreadyVerify] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [pageMessage, setPageMessage] = useState("");


  useEffect(async () => {
    setLoading(true)

    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get('value');

    if(value){
      let userId = JSON.parse(deCryptFun(value));

      const verifyEmailResponse = await verifyEmailConfirmFunc(userId)

      if(verifyEmailResponse && verifyEmailResponse.status === "Success"){

        setPageTitle("Success")
        setPageMessage("Your email has been successfully verified.")

      }else{

        setPageTitle("Failed")
        setPageMessage(verifyEmailResponse.message)

      }


    }else {
      // showToast("The user was not found.", "error");
      // navigate(SIGNIN_ROUTE);
      backFun();
    }

    setLoading(false)
    
  }, []);

  const verifyEmailConfirmFunc = async (userId) => {
   
  
    const dataVerifyEmailInput = { email: userId };

    const config = {
      method: "PUT",
      url: USER_VERIFY_EMAIL_URL,
      data: {
        webString: enCryptFun(JSON.stringify(dataVerifyEmailInput)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      return parsedResponse;
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
        setIsAlreadyVerify(true)
        return v;
      }
    } finally {
      
    }
  };

  
  const backFun = () => {
    window.location.replace(`/signin`);
    // navigate(SIGNIN_ROUTE);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={1}>
          <Grid sx={{ p: "0 !important" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                height: { xs: "auto", md: "98vh" },
                padding: { xs: "40px", md: "40px 59px" },
                paddingRight: { xs: "40px", md: "68px" },
                paddingTop: "46px",
              }}
              className="welcome-box"
            >
              {/* <Box className="login-bg-color login-bg-top"></Box> */}
              <img className="logo" src={Logo} />
              <h1 className="login-title">
                Welcome to
                <br /> <span className="smart-billing">
                  Smart Billing
                </span> by <br />
                HOS Resources
              </h1>
              <p className="login-text">
                Smart Billing is the billing solution that enables HOS Resources
                to quickly collect, consolidate, and invoice billing statements
                from brokers in the field.
              </p>
              {/* <Box className="login-bg-color login-bg-bottom"></Box> */}
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChanges("panel1")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  About
                </AccordionSummary>
                <AccordionDetails>
                  HOS Resources, LLC (“HOS”) is a Lafayette, Louisiana based
                  energy consulting firm formed in 2015. HOS retains independent
                  contractor landmen to provide our clients with quality land
                  services throughout the country. These include title,
                  abstracting, curative, leasing, right-of-way acquisitions,
                  land acquisition, and any other services required to meet our
                  clients’ needs.
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChanges("panel2")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Leadership & Experience
                </AccordionSummary>
                <AccordionDetails>
                  HOS’s founders combine for over 34 years of industry
                  experience in negotiating and acquiring oil and gas leases,
                  right-of-ways, seismic permits and options, as well as surface
                  leases throughout the country, including Louisiana,
                  Mississippi, Alabama, Texas, Utah, Minnesota, New York and
                  Illinois. They have represented oil and gas exploration
                  companies, midstream pipeline and storage companies, renewable
                  energy developers, law firms, large landowners, working
                  interest participants, private equity funds, and banks. HOS’s
                  senior landmen have over 50 years combined industry
                  experience.
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid sx={{ background: "#fff" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                padding: {
                  xs: "40px 30px",
                  md: "40px 40px 40px 20px",
                  lg: "40px 100px 40px 76px",
                },
                pt: "42px !important",
              }}
              className="form-box login"
            >
              {loading ? <CustomPageLoading /> : ""}

              <Stack
                sx={{
                  mb: "14px",
                  cursor: "pointer",
                }}
                direction="row"
                spacing={0}
                justifyContent="flex-start"
                alignItems="center"
                onClick={backFun}
              >
                <img style={{ cursor: "pointer" }} src={backIcon} />
                <p className="back-text">Back</p>
              </Stack>

              <Box
                    sx={{
                      textAlign: "center",
                      mt: { xs: "40px", md: "80px" },
                    }}
                  >
                    <img
                      style={{ maxWidth: "218px", width: "100%" }}
                      className="logo"
                      src={isAlreadyVerify ? EmailVerificationAlreadyDone :EmailSuccessImg }
                    />

                    <Typography
                      sx={{ mt: "15px" ,md: "10px" }}
                      className="password-title"
                      variant="h2"
                    >
                      {pageTitle}
                    </Typography>
                    <p className="password-subtext">
                      {pageMessage}
                    </p>

                    <Button
                      sx={{
                        padding: "11px 15px !important",
                        width: "auto !important",
                        mt: "12px !important",
                      }}
                      className="login-btn"
                      variant="contained"
                      size="large"
                      onClick={backFun}
                    >
                      Back to login
                    </Button>
                  </Box>

             
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default EmailConfirmation;
